/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import { useTasksFilter } from "./hooks";
import GeneralFilter from "../../Shared/Filter/GeneralFilter";
import { resetTaskFilters } from "../../../store/filters/tasks/reducers";

export const TasksFilter = () => {
  const { dispatch, filters, formControlSx } = useTasksFilter();

  return (
    <>
      <GeneralFilter
        dispatch={dispatch}
        filters={filters}
        formControlSx={formControlSx}
        resetFilters={resetTaskFilters}
        showSearch={false}
      />
    </>
  );
};

export default TasksFilter;
